import { DispatchOf } from "../utils";
import { fetchMixpanelDashboards } from "../../services/mixpanelService";
import { ServicesActions } from "../reducers/servicesReducer";
import * as types from "../../constants";
import {ErrorsActions} from "../reducers/toastsReducer";

export function fetchOpenedTheAccessibility(
  token: string,
  date: {from: string, to: string},
  company?: string
) {
  return async (dispatch: DispatchOf<ServicesActions> & DispatchOf<ErrorsActions>) => {
    return fetchMixpanelDashboards(
      token,
      date,
      'open_accessed_widget',
      company
    ).then((response: any) => {
        dispatch({
          type: types.FETCH_OPENED_THE_ACCESSIBILITY,
          payload: response,
        });
      }).catch((error) => {
      dispatch({
        type: types.ADD_TOAST,
        payload: error
      })
    })
  };
}

export function fetchInteractionWithTheAcc(
  token: string,
  date: {from: string, to: string},
  company?: string
) {
  return async (dispatch: DispatchOf<ServicesActions> & DispatchOf<ErrorsActions>) => {
    return fetchMixpanelDashboards(
      token,
      date,
      'interact_accessed_widget',
      company
    ).then((response: any) => {
      dispatch({
        type: types.FETCH_INTERACTION_WITH_THE_ACC,
        payload: response,
      });
    }).catch((error) => {
      dispatch({
        type: types.ADD_TOAST,
        payload: error
      })
    })
  };
}
export function fetchActionPerVisitor(
  token: string,
  date: {from: string, to: string},
  company?: string
) {
  return async (dispatch: DispatchOf<ServicesActions> & DispatchOf<ErrorsActions>) => {
    return fetchMixpanelDashboards(
      token,
      date,
      'actions_per_visitor_widget',
      company
    ).then((response: any) => {
      dispatch({
        type: types.FETCH_ACTION_PER_VISITOR,
        payload: response,
      });
    }).catch((error) => {
      dispatch({
        type: types.ADD_TOAST,
        payload: error
      })
    })
  };
}

export function clearMixpanelData() {
  return ({
    type: types.CLEAR_MIXPANEL_DATA
  })
}